/**
 * Customer Account Functionality Enhancement
 * Ensures account button, sign-in, and related features work across all browsers
 */

(function () {
    'use strict';

    // Wait for DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function () {

        // Ensure Bootstrap is loaded
        if (typeof bootstrap === 'undefined') {
            console.error('Bootstrap is not loaded. Account functionality may not work properly.');
            return;
        }

        /**
         * Initialize all account-related offcanvas elements
         */
        var SHOP_PATH_KEY = 'casasola_shop_path';
        var OPEN_ACCOUNT_KEY = 'casasola_open_account';

        function initializeOffcanvas() {
            const accountOffcanvasEl = document.getElementById('customerAccount');
            const loginOffcanvasEl = document.getElementById('customerLogin');
            const accountMenuEl = document.getElementById('customerAccountMenu');

            if (accountOffcanvasEl) {
                // Ensure offcanvas is properly initialized
                const accountOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(accountOffcanvasEl);

                // Add event listener for when offcanvas is shown
                accountOffcanvasEl.addEventListener('shown.bs.offcanvas', function () {
                    // Focus on first input when opened
                    const firstInput = accountOffcanvasEl.querySelector('input:not([type="hidden"])');
                    if (firstInput) {
                        setTimeout(function () {
                            firstInput.focus();
                        }, 100);
                    }
                });
            }

            if (loginOffcanvasEl) {
                const loginOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(loginOffcanvasEl);

                loginOffcanvasEl.addEventListener('shown.bs.offcanvas', function () {
                    const emailInput = document.getElementById('CustomerEmail');
                    if (emailInput) {
                        setTimeout(function () {
                            emailInput.focus();
                        }, 100);
                    }
                });
            }

            if (accountMenuEl) {
                bootstrap.Offcanvas.getOrCreateInstance(accountMenuEl);
            }
        }

        /**
         * Add fallback click handlers for account buttons
         * This ensures functionality even if Bootstrap data attributes fail
         */
        function addFallbackHandlers() {
            // Account button fallback
            const accountButtons = document.querySelectorAll('[data-bs-target="#customerAccount"]');
            accountButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    const offcanvasEl = document.getElementById('customerAccount');
                    if (offcanvasEl) {
                        const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
                        offcanvas.show();
                    }
                });
            });

            // Login button fallback
            const loginButtons = document.querySelectorAll('[data-bs-target="#customerLogin"]');
            loginButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    const offcanvasEl = document.getElementById('customerLogin');
                    if (offcanvasEl) {
                        const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
                        offcanvas.show();
                    }
                });
            });

            const accountMenuButtons = document.querySelectorAll('[data-bs-target="#customerAccountMenu"]');
            accountMenuButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    openAccountMenu();
                });
            });
        }

        /**
         * Handle form validation errors
         */
        function handleFormErrors() {
            // If there are form errors, automatically open the relevant offcanvas
            const accountForm = document.getElementById('create_customer');
            const loginForm = document.getElementById('customerLoginForm');

            if (accountForm && accountForm.querySelector('.alert-danger')) {
                const offcanvasEl = document.getElementById('customerAccount');
                if (offcanvasEl) {
                    const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
                    offcanvas.show();
                }
            }

            if (loginForm && loginForm.querySelector('.alert-danger')) {
                const offcanvasEl = document.getElementById('customerLogin');
                if (offcanvasEl) {
                    const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
                    offcanvas.show();
                }
            }
        }

        /**
         * Handle password recovery link clicks
         */
        function setupPasswordRecovery() {
            const forgotPasswordLinks = document.querySelectorAll('a[href="#recover"]');

            forgotPasswordLinks.forEach(function (link) {
                link.addEventListener('click', function (e) {
                    e.preventDefault();

                    const recoverSection = document.getElementById('recover');
                    const loginSection = document.getElementById('login');

                    if (recoverSection && loginSection) {
                        recoverSection.classList.remove('d-none');
                        loginSection.classList.add('d-none');
                        document.body.classList.add('hide-customer-login');

                        // Focus on email input
                        setTimeout(function () {
                            const emailInput = document.getElementById('RecoverEmail');
                            if (emailInput) {
                                emailInput.focus();
                            }
                        }, 100);
                    }
                });
            });

            // Handle cancel link in recover password form
            const cancelLinks = document.querySelectorAll('#recover a[href="#login"]');
            cancelLinks.forEach(function (link) {
                link.addEventListener('click', function (e) {
                    e.preventDefault();

                    const recoverSection = document.getElementById('recover');
                    const loginSection = document.getElementById('login');

                    if (recoverSection && loginSection) {
                        recoverSection.classList.add('d-none');
                        loginSection.classList.remove('d-none');
                        document.body.classList.remove('hide-customer-login');
                        window.location.hash = '';
                    }
                });
            });
        }

        function rememberShopPath() {
            var pageType = window.theme && window.theme.pageType ? String(window.theme.pageType) : '';
            if (pageType.indexOf('customers') === 0) {
                return;
            }
            try {
                var url = new URL(window.location.href);
                url.searchParams.delete('account');
                var stored = url.pathname;
                if (url.searchParams.toString()) {
                    stored += '?' + url.searchParams.toString();
                }
                sessionStorage.setItem(SHOP_PATH_KEY, stored || '/');
            } catch (e) {}
        }

        function openAccountMenu() {
            var accountMenuEl = document.getElementById('customerAccountMenu');
            if (!accountMenuEl || typeof bootstrap === 'undefined') {
                return;
            }
            bootstrap.Offcanvas.getOrCreateInstance(accountMenuEl).show();
        }

        function clearAccountOpenParam() {
            try {
                var url = new URL(window.location.href);
                if (url.searchParams.has('account')) {
                    url.searchParams.delete('account');
                    var next = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
                    window.history.replaceState({}, document.title, next);
                }
            } catch (e) {}
        }

        function openAccountMenuAfterLogin() {
            if (!window.theme || !window.theme.customerLoggedIn) {
                return;
            }

            var shouldOpen = false;
            try {
                shouldOpen = sessionStorage.getItem(OPEN_ACCOUNT_KEY) === '1';
                if (shouldOpen) {
                    sessionStorage.removeItem(OPEN_ACCOUNT_KEY);
                }
            } catch (e) {}

            try {
                var params = new URLSearchParams(window.location.search);
                if (params.get('account') === 'open') {
                    shouldOpen = true;
                    clearAccountOpenParam();
                }
            } catch (e) {}

            if (shouldOpen) {
                openAccountMenu();
            }
        }

        function setupLoginReturn() {
            var loginForms = document.querySelectorAll('#customerLoginForm, form[action*="/account/login"]');
            loginForms.forEach(function (form) {
                form.addEventListener('submit', function () {
                    try {
                        sessionStorage.setItem(OPEN_ACCOUNT_KEY, '1');
                    } catch (e) {}
                });
            });
        }

        /**
         * Initialize all functionality
         */
        function init() {
            rememberShopPath();
            initializeOffcanvas();
            addFallbackHandlers();
            handleFormErrors();
            setupPasswordRecovery();
            setupLoginReturn();
            openAccountMenuAfterLogin();
        }

        // Run initialization
        init();

        // Re-initialize on hash change (for password recovery)
        window.addEventListener('hashchange', function () {
            if (window.location.hash === '#recover') {
                const recoverSection = document.getElementById('recover');
                const loginSection = document.getElementById('login');

                if (recoverSection && loginSection) {
                    recoverSection.classList.remove('d-none');
                    loginSection.classList.add('d-none');
                    document.body.classList.add('hide-customer-login');
                }
            } else if (window.location.hash === '#login' || window.location.hash === '') {
                const recoverSection = document.getElementById('recover');
                const loginSection = document.getElementById('login');

                if (recoverSection && loginSection) {
                    recoverSection.classList.add('d-none');
                    loginSection.classList.remove('d-none');
                    document.body.classList.remove('hide-customer-login');
                }
            }
        });
    });
})();
